import React from 'react';

/**
 * Anel de progresso das etapas (feitas / total). Usa a cor do texto em volta
 * (currentColor): o trilho fica claro e o arco mostra o quanto já foi feito.
 */
function StepsProgressRing({ done, total, size = 14 }) {
    const stroke = 2;
    const radius = (size - stroke) / 2;
    const circumference = 2 * Math.PI * radius;
    const ratio = total > 0 ? Math.min(done / total, 1) : 0;

    return (
        <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} aria-hidden="true" style={{ flexShrink: 0, transform: 'rotate(-90deg)' }}>
            <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke="currentColor" strokeOpacity="0.18" strokeWidth={stroke} />
            {ratio > 0 && (
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={stroke}
                    strokeLinecap="round"
                    strokeDasharray={`${circumference * ratio} ${circumference}`}
                />
            )}
        </svg>
    );
}

export default StepsProgressRing;
